export const STORAGE_SELECT_MESSAGE = (t) => ({
  DEFAULT: t('key292'),
  NO_STORAGE: t('key291'),
  VALID_ERROR: t('key292'),
});
